import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Hearthhop needs a root element to mount.');

createRoot(root).render(<App />);
